import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { useParams, Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "../terms/Header.js";
import ApplicantsDetail from "./applicantsDetail.js";
import ApplicantsOneOnOne from "./applicantsOneOnOne.js";
import AlertDialog from "../../components/AlertDialog.js";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SelectQualifiedApplicantsDialog from "./selectQualifiedApplicantsDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.green`]: {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.green:hover`]: {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E3F2FD !important",
    },
    [`& .${gridClasses.row}.green.Mui-selected`]: {
      backgroundColor: "#EFFFCA !important",
    },
  },
  textFieldStyle: {
    // height: 55,
    // marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      height: 45,
      borderRadius: 10,
      fontSize: 16,
    },
  },
  noOfSeatsBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px",
  },
  noOfSeatsTextStyle: {
    width: 60,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    paddingLeft: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
}));

function ApplicantsBoard() {
  const { termUuid } = useParams();
  const [termName, setTermName] = useState("");
  const [termLink, setTermLink] = useState(null);
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [numExpandedRow, setNumExpandedRow] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [noOfSeats, setNoOfSeats] = useState(1);
  const [editedNoOfSeats, setEditedNoOfSeats] = useState(1);
  const [qualAppsList, setQualAppsList] = useState([]);
  const [openSelQualDlg, setOpenSelQualDlg] = useState(false);
  const [editingNoOfSeats, setEditingNoOfSeats] = useState(false);
  const [focusNoOfSeats, setFocusNoOfSeats] = useState(false);

  const [getTermData] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID, {
    fetchPolicy: "network-only",
  });

  const getTerm = async () => {
    if (termUuid) {
      // Get term information
      const {
        loading: termDataLoading,
        error: termDataError,
        data: termData,
      } = await getTermData({
        variables: { termUuid: termUuid },
      });

      if (!termDataLoading && termData && termData.getTermDataByTermUuid) {
        setTermName(termData.getTermDataByTermUuid.name);
        if (!termData.getTermDataByTermUuid.urlActivated)
          setTermLink(`${project_url}/terms/${termUuid}`);
      }
      if (
        termDataError &&
        termDataError.graphQLErrors &&
        termDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };
  useEffect(() => {
    (() => getTerm())();
  }, [termUuid]);

  const [applicantsList, setApplicantsList] = useState([
    {
      id: 1,
      applicantName: "Giacomo Guilizzoni",
      email: "giacomo.guilizzoni@gmail.com",
      country: "Italy",
      assignedScore: 20,
      dateApplied: "6-13-2024",
      pastApplication: "Applied/Not Accepted",
      awardedScore: 20,
      expanded: false,
    },
    {
      id: 2,
      applicantName: "Marco Botton",
      email: "marco.botton@gmail.com",
      country: "England",
      assignedScore: 15,
      dateApplied: "6-16-2024",
      pastApplication: "New",
      awardedScore: 15,
      expanded: false,
    },
    {
      id: 3,
      applicantName: "Mariah MacArthur",
      email: "mariah.macArthur@gmail.com",
      country: "USA",
      assignedScore: 15,
      dateApplied: "6-16-2024",
      pastApplication: "Accepted/Dropped",
      awardedScore: 15,
      expanded: false,
    },
    {
      id: 4,
      applicantName: "Valerie Liberty",
      email: "valerie.Liberty@gmail.com",
      country: "USA",
      assignedScore: 15,
      dateApplied: "6-20-2024",
      pastApplication: "New",
      awardedScore: 15,
      expanded: false,
    },
    {
      id: 5,
      applicantName: "Johny Smith",
      email: "johny.smith@gmail.com",
      country: "South Africa",
      assignedScore: 15,
      dateApplied: "6-19-2024",
      pastApplication: "New",
      awardedScore: 15,
      expanded: false,
    },
    {
      id: 6,
      applicantName: "Suzanna Wolfgang",
      email: "suzanna.wolfgang@gmail.com",
      country: "Germany",
      assignedScore: 15,
      dateApplied: "6-20-2024",
      pastApplication: "New",
      awardedScore: 15,
      expanded: false,
    },
  ]);
  const [quesList, setQuesList] = useState([]);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  const [errorMsg, setErrorMsg] = useState({
    noOfSeats: "",
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    let qualList = [];
    //sorting
    // applicantsList.sort((a, b) =>
    //   parseInt(a.awardedScore) < parseInt(b.awardedScore) ? 1 : -1
    // );
    applicantsList.map((app, index) => {
      if (index < noOfSeats) qualList.push(app);
    });
    setQualAppsList(qualList);
  }, [noOfSeats]);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const validateNoOfSeats = (value) => {
    if (parseInt(value) < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (parseInt(value) > 99) {
      setErrorMsg({ noOfSeats: "Enter an integer less than 99." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else {
      setErrorMsg({});
    }
    setEditedNoOfSeats(value);
  };
  const handleChangeExpandStatus = async (id) => {
    let foundRow = findAnd.returnFound(applicantsList, {
      id: id,
    });
    let expandedRowCounter = 0;
    await applicantsList.map((app) => {
      if (app.expanded) expandedRowCounter += 1;
    });
    // Check number of expanded rows
    if (expandedRowCounter === 0)
      if (!foundRow.expanded) setNumExpandedRow(1);
      else setNumExpandedRow(0);

    if (expandedRowCounter === 1)
      if (!foundRow.expanded) setNumExpandedRow(2);
      else setNumExpandedRow(0);

    if (expandedRowCounter > 1)
      if (!foundRow.expanded) return;
      else setNumExpandedRow(1);
    /////
    let appsList = findAnd.changeProps(
      applicantsList,
      { id: id },
      {
        expanded: foundRow ? !foundRow.expanded : false,
      }
    );
    var index = expandedRows.findIndex((item) => item.id === foundRow.id);
    let draftExpandedRows = update(
      expandedRows,
      index === -1 ? { $push: [foundRow] } : { $splice: [[index, 1]] }
    );
    setExpandedRows(draftExpandedRows);
    setApplicantsList(appsList);
  };
  const columns = [
    {
      field: "action",
      headerName: "",
      headerClassName: "super-app-theme--header",
      width: 10,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        return !rows.row.expanded ? (
          <ArrowRightIcon
            color={
              numExpandedRow === 2 && !rows.row.expanded ? "disabled" : "action"
            }
            style={{
              cursor:
                numExpandedRow === 2 && !rows.row.expanded ? "" : "pointer",
              height: 40,
              width: 40,
              paddingTop: 5,
            }}
            onClick={() => handleChangeExpandStatus(rows.row.id)}
          />
        ) : (
          <ArrowDropDownIcon
            color="primary" //sx={{color:"#0D47A1"}}
            style={{ cursor: "pointer", height: 40, width: 40, paddingTop: 5 }}
            onClick={() => handleChangeExpandStatus(rows.row.id)}
          />
        );
      },
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "assignedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Assigned Score",
      minWidth: 180,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "dateApplied",
      headerClassName: "super-app-theme--header",
      headerName: "Date Applied",
      minWidth: 180,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "pastApplication",
      headerClassName: "super-app-theme--header",
      headerName: "Past Application",
      minWidth: 200,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "awardedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 170,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];

  const rows = applicantsList.map((app, index) => ({
    index,
    id: app.id,
    applicantName: app.applicantName,
    email: app.email,
    assignedScore: app.assignedScore,
    dateApplied: app.dateApplied,
    pastApplication: app.pastApplication,
    awardedScore: app.awardedScore,
    expanded: app.expanded,
  }));
  if (loadContent)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: termName, link: termLink },
            { label: "Applicants", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography
              variant="body1"
              style={{ marginBottom: 10, fontWeight: 600 }}
            >
              Applicants Qualification
            </Typography>
          </Box>
          <Divider />
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Term Period:
            </Typography>
            <Typography variant="h3">July 8, 2024 - August 12, 2024</Typography>
          </Box>

          <Grid
            container
            spacing={1}
            style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
          >
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                paddingTop: editingNoOfSeats ? 0 : 10,
              }}
            >
              <Typography
                variant="h2"
                style={{
                  paddingRight: 10,
                  paddingTop: editingNoOfSeats ? 10 : 0,
                }}
              >
                No of Available Seats:
              </Typography>
              {!editingNoOfSeats ? (
                <Box className={classes.noOfSeatsBoxStyle}>
                  <Typography
                    variant="h1"
                    className={classes.noOfSeatsTextStyle}
                    onClick={() => {
                      setEditingNoOfSeats(true);
                      setFocusNoOfSeats(true);
                    }}
                  >
                    {editedNoOfSeats}
                  </Typography>
                  <IconButton>
                    <EditOutlinedIcon
                      onClick={() => {
                        setEditingNoOfSeats(true);
                        setFocusNoOfSeats(true);
                      }}
                    />
                  </IconButton>
                </Box>
              ) : (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "center",
                    paddingTop: 12,
                  }}
                >
                  <TextField
                    className={classes.textFieldStyle}
                    id="outlined-multiline-static"
                    variant="outlined"
                    type="number"
                    value={editedNoOfSeats}
                    variant="outlined"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (!errorMsg.noOfSeats) {
                          setNoOfSeats(editedNoOfSeats);
                          setEditingNoOfSeats(false);
                        }
                      }
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                      if (e.keyCode >= 65 && e.keyCode <= 90) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => validateNoOfSeats(e.target.value)}
                    InputProps={{
                      inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                    }}
                    id="noOfSeats"
                    error={errorMsg.noOfSeats}
                  />
                  <Box
                    className={classes.iconStyle}
                    onClick={() => {
                      if (!errorMsg.noOfSeats) {
                        setNoOfSeats(editedNoOfSeats);
                        setEditingNoOfSeats(false);
                      }
                    }}
                  >
                    <CheckIcon sx={{ color: "gray", cursor: "pointer" }} />
                  </Box>
                  <Box
                    className={classes.iconStyle}
                    style={{ marginLeft: 7 }}
                    onClick={() => {
                      setEditingNoOfSeats(false);
                      setEditedNoOfSeats(noOfSeats);
                      setErrorMsg({});
                    }}
                  >
                    <CloseIcon sx={{ color: "gray", cursor: "pointer" }} />
                  </Box>
                  {errorMsg.noOfSeats && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyle} error>
                        {errorMsg.noOfSeats}
                      </FormHelperText>
                    </Box>
                  )}
                </Box>
              )}
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                onClick={() => setOpenSelQualDlg(true)}
              >
                Select Qualified Applicants
              </Button>
            </Grid>
          </Grid>
          <Box style={{ height: 372 }}>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              getRowId={(row) => row.id}
              getRowClassName={(params) => {
                if (params.row.index + 1 <= noOfSeats) return "green";
                if (params.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              //  autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </Box>
          {numExpandedRow === 1 && expandedRows.length > 0 && (
            <ApplicantsDetail
              applicant={expandedRows[0]}
              applySelectedQues={(selQuesList) => setQuesList(selQuesList)}
              initQuesList={quesList}
            />
          )}
          {numExpandedRow === 2 && expandedRows.length > 1 && (
            <ApplicantsOneOnOne
              applicants={expandedRows}
              applySelectedQues={(selQuesList) => setQuesList(selQuesList)}
              initQuesList={quesList}
            />
          )}
        </div>
        {openSelQualDlg && (
          <SelectQualifiedApplicantsDialog
            qualAppsList={qualAppsList}
            applySelections={() => setOpenSelQualDlg(false)}
            closeDialog={() => setOpenSelQualDlg(false)}
          />
        )}
      </div>
    );
  else return;
}

export default ApplicantsBoard;
